import { Component } from '@angular/core';

import { DynamicFormService } from '@ntap/common';

import {
  ImagePanelItemProviderService,
  ParentItemProviderService
} from '@app/shared';

@Component({
  selector: 'app-agent',
  templateUrl: './agent.component.html',
  styleUrls: ['./agent.component.scss'],
  providers: [
    DynamicFormService,
    // { provide: FORM_SERVICE_PROVIDER_TOKEN, useExisting: DynamicFormService }, // OPREZ, ovo ne bi smjeli koristiti na komponentama s child komponentama s formama jer onda SVE niže komponente shareaju isti form service
    ParentItemProviderService,
    ImagePanelItemProviderService
  ]
})
export class AgentComponent {}
